import { msalInstance } from './msalConfig';

const combine = (...paths) => {
    return paths
      .map(path => path.replace(/^[\\|/]/, "").replace(/[\\|/]$/, ""))
      .join("/")
      .replace(/\\/g, "/")
}
  
export const getToken = async (command) => {
    let accessToken = "";
    let authParams = null;
  
    switch (command.type) {
        case "SharePoint":
        case "SharePoint_SelfIssued":
            // constroi o escopo usando o método combine e com permissões do SharePoint
            authParams = { scopes: [`${combine(command.resource, ".default")}`] };
            break;
        case "oAuth":
        case "OAuth": {
            const resource = command.resource || "";
            const isSharePoint = resource.includes(".sharepoint.com");
            if (isSharePoint) {
                authParams = { scopes: [`${combine(resource, ".default")}`] };
            } else {
                return ""; // ignora recursos não-SharePoint, sem erro
            }
            break;
        }
        default:
            return "";
    }
    if (!authParams) return "";
    
    try {
        // tenta obter token silenciosamente primeiro
        const resp = await msalInstance.acquireTokenSilent(authParams);
        accessToken = resp.accessToken;
    } catch (e) {
        // se falhar, tenta com popup (requer consentimento do usuário)
        const account = msalInstance.getActiveAccount();
        const resp = await msalInstance.loginPopup(authParams);
        msalInstance.setActiveAccount(resp.account);
  
        if (resp.idToken) {
            // após login via popup, tenta silenciosamente novamente
            const resp2 = await msalInstance.acquireTokenSilent(authParams);
            accessToken = resp2.accessToken;
        }
    }
  
    return accessToken;
};
  
// extrair o tenant do email
export const getSharePointBaseUrl = (email) => {
    if (!email) {
      throw new Error('Email é necessário para obter baseUrl do SharePoint');
    }
    const domain = email.split('@')[1];
    const tenant = domain.split('.').join('');
    return `https://${tenant}-my.sharepoint.com`;
};

// Função auxiliar para pegar token apenas para o GRAPH (diferente do token do SharePoint)
const getGraphAccessToken = async () => {
    const account = msalInstance.getActiveAccount();
    const request = {
        scopes: ["Files.Read"], // Necessário para ler informações do Drive
        account: account
    };

    try {
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (e) {
        const response = await msalInstance.acquireTokenPopup(request);
        return response.accessToken;
    }
};

// Nova função para descobrir a URL real
export const resolveOneDriveBaseUrl = async () => {
    try {
        const token = await getGraphAccessToken();

        // Chama a API do Graph para pegar detalhes do OneDrive do usuário
        const response = await fetch("https://graph.microsoft.com/v1.0/me/drive", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Erro ao buscar drive: ${response.statusText}`);
        }

        const data = await response.json();
        
        // data.webUrl retorna algo como: https://tenant-my.sharepoint.com/personal/user_domain_com
        // Nós precisamos apenas da "origin" (https://tenant-my.sharepoint.com)
        const webUrl = data.webUrl;
        const urlObj = new URL(webUrl);
        
        return urlObj.origin; 

    } catch (error) {
        console.error("Falha ao resolver URL do OneDrive via Graph:", error);
        throw error;
    }
};
